import s from '../collegesItem.module.css'
import {useEffect, useState} from "react";

import {Button, Select} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import {teams as teamsApi} from "@api"


const ModalAddTeams = ({userId, teams, setActive, update}) => {
  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);

  const [teamsList, setTeamsList] = useState([]);
  const [isHead, setIsHead] = useState(null);

  const [teamId, setTeamId] = useState(null);
  
  useEffect(() => {
    teamsApi.getAllIndex()
    .then(res => setTeamsList(res.data));
  }, []);
   
  const add = () => {
    let iam = false;
    
    teams.forEach(element => {
        if(element.id==teamId){
            iam = true;
        }
    })
    if(teamId){
        if(iam){
            addAlert({ text: 'Этот пользователь уже есть в этой команде' });
        }
        else{
            setLoading(true)
            teamsApi.addAnEmployeeToTeam({
                userId: [userId],
                teamId: teamId,
                isHead: isHead
            })
            .then((res) => {
              if(res.data){
                addAlert({ text: 'Пользователь в команду успешно добавлен' });
                update('teams')
                setActive(false);
              }
            })
            .finally((res)=>{
                setLoading(false)
            })
        }
    }
    else{
        addAlert({ text: 'Сперва выберите команду' });
    }
  }
  
  return <div className="modal_teams">
    <h2 className="modal__title">Добавить команду</h2>
    <div className={s.body}>
        <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Выберите команду</span>
        <Select 
          className={s.input}
          style={{width: '100%'}} 
          onChange={(value) => setTeamId(value)} 
          placeholder='Выберите команду'
          options={[...teamsList.filter(el=>el?.label!=='Ученики').map(el => ({ label: el?.label, value: el?.id }))]} 
        />

        <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Сделать руководителем команды</span>
        <Select 
          className={s.input}
          style={{width: '100%'}} 
          onChange={(value) => setIsHead(value)} 
          placeholder='Сделать руководителем команды'
          options={[{ label: 'Да', value: userId }, { label: 'Нет', value: null }]} 
        />
      <Button disabled={loading} onClick={add}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddTeams